export default __webpack_public_path__ + "f36537bc16ee4dc810142ca6e61101b1.svg";